//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mdiCrownOutline, mdiCart } from '@mdi/js'
import { useUtils } from '@core/libs/i18n'

export default {
  props: {
    time: {
      type: String,
      default: '',
    },
    isPremium: {
      type: Boolean,
      default: true,
    },
    showTime: {
      type: Boolean,
      default: true,
    },
    showLabel: {
      type: Boolean,
      default: false,
    },
    showCenterIcon: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    const { t } = useUtils()

    return {
      t,

      icons: {
        mdiCrownOutline,
        mdiCart,
      },
    }
  },
}
